import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image ,Font} from '@react-pdf/renderer';
import NotoSans from '../Assets/Fonts/static/NotoSans_Condensed-Bold.ttf';
Font.register({
  family: "NotoSans",
  src: NotoSans,
});

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: 'Helvetica',
    fontSize: 12,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  headerLeft: {
    width: '70%',
  },
  headerRight: {
    width: '30%',
    alignItems: 'flex-end',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  logo: {
    width: 60,
    height: 60,
  },
  companyInfo: {
    fontSize: 10,
    color: '#444',
    marginTop: 5,
    lineHeight: 1.4,
  },
  invoiceInfo: {
    marginBottom: 10,
    marginTop: 20,
    borderTopWidth: 1,
    borderTopColor: '#ddd',
    paddingTop: 15,
  },
  infoText: {
    fontSize: 10,
    marginBottom: 5,
  },
  email: {
    fontSize: 10,
    color: '#444',
    marginTop: 2,
  },
  invoiceId: {
    fontSize: 11,
    marginBottom: 5,
    fontWeight: 'bold',
  },
  testMode: {
    fontSize: 10,
    color: '#666',
    marginTop: 15,
    fontStyle: 'italic',
  },
  billToSection: {
    marginTop: 10,
    marginBottom: 15,
    borderTopWidth: 1,
    borderTopColor: '#eee',
    paddingTop: 10,
  },
  billToTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  billToInfo: {
    fontSize: 10,
    color: '#444',
    lineHeight: 1.4,
  },
  table: {
    marginTop: 20,
  },
  tableHeader: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    paddingBottom: 8,
    fontWeight: 'bold',
    fontSize: 10,
    backgroundColor: '#f9f9f9',
    paddingVertical: 8,
    paddingHorizontal: 5,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    paddingVertical: 12,
    paddingHorizontal: 5,
  },
  descriptionCell: {
    flex: 3,
    fontSize: 10,
  },
  planSubtext: {
    fontSize: 8,
    color: '#666',
    marginTop: 2,
  },
  cancellationPolicy: {
    fontSize: 8,
    color: '#d32f2f',
    marginTop: 2,
    fontStyle: 'italic',
  },
  unitPriceCell: {
    fontFamily: 'NotoSans',
    flex: 1,
    fontSize: 10,
    textAlign: 'right',
  },
  qtyCell: {
    fontFamily: 'NotoSans',
    flex: 0.5,
    fontSize: 10,
    textAlign: 'center',
  },
  amountCell: {
    fontFamily: 'NotoSans',
    flex: 1,
    fontSize: 10,
    textAlign: 'right',
  },
  totalSection: {
    marginTop: 15,
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 5,
  },
  totalLabel: {
    fontSize: 10,
    width: 100,
  },
  totalValue: {
    fontFamily: 'NotoSans',
    fontSize: 10,
    width: 80,
    textAlign: 'right',
  },
  taxNote: {
    fontSize: 9,
    color: '#666',
    marginTop: 8,
    fontStyle: 'italic',
    textAlign: 'right',
    paddingRight: 5,
  },
  amountPaidSection: {
    marginTop: 30,
    borderTopWidth: 1,
    borderTopColor: '#000',
    paddingTop: 10,
  },
  amountPaidTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#444',
  },
  amountPaidValue: {
    fontFamily: 'NotoSans',
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 5,
    color: '#000',
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 40,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: '#eee',
  },
  footerText: {
    fontSize: 10,
    color: '#666',
    fontWeight: 'bold',
  },
  footerValue: {
    fontSize: 10,
    color: '#444',
    marginTop: 3,
  },
  pageNumber: {
    position: 'absolute',
    bottom: 30,
    right: 30,
    fontSize: 10,
    color: '#666',
  },
  razorpayBranding: {
    fontSize: 9,
    color: '#888',
    marginTop: 2,
  },
  thankYouCard: {
    marginTop: 40,
    padding: 15,
    backgroundColor: '#f9f9f9',
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '#eee',
    textAlign: 'center',
  },
  thankYouText: {
    fontSize: 12,
    color: '#444',
    textAlign: 'center',
  },
  thankYouSubtext: {
    fontSize: 9,
    color: '#666',
    marginTop: 5,
    textAlign: 'center',
    fontStyle: 'italic',
  },
});

// Create Invoice component
const Invoice = ({invoice}) => {
  const {
    customerName,
    invoiceId,
    customerMail,
    customerPhone,
    planName,
    quantity,
    total,
    paidDate,
  } = invoice;




  // Add a base64 encoded placeholder logo (in a real application you would use your actual logo)
  
  const logoUrl = 'https://www.abhram.com/assets/images/icon.png';

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <View style={styles.headerLeft}>
            <Text style={styles.title}>Abhram Technologies</Text>
            <Text style={styles.email}>io@abhram.com</Text>
            <Text style={styles.companyInfo}>
              ABHRAM TECHNOLOGIES PVT LTD{'\n'}
              2nd Floor, Kallarikkal House,{'\n'}
              Arpana Nagar, Palluruthy{'\n'}
              Kochi-682006{'\n'}
              GSTIN/UIN: 32AAZCA5725E1ZK{'\n'}
              State Name: Kerala, Code: 32
            </Text>
          </View>
          <View style={styles.headerRight}>
            {/* Using a base64 placeholder for the logo */}
            <Image style={styles.logo} src={logoUrl} />
          </View>
        </View>
        
        <View style={styles.invoiceInfo}>
        <Text style={styles.billToTitle}>BILL TO:</Text>
          <Text style={styles.infoText}>Invoice ID: {invoiceId}</Text>
          <Text style={styles.infoText}>Customer: {customerName}</Text>
          <Text style={styles.infoText}>Email: {customerMail}</Text>
          <Text style={styles.infoText}>Phone: {customerPhone}</Text>
          <Text style={styles.infoText}>Date: {paidDate}</Text>
        </View>
        

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.descriptionCell}>DESCRIPTION</Text>
            <Text style={styles.unitPriceCell}>UNIT PRICE</Text>
            <Text style={styles.qtyCell}>QTY</Text>
            <Text style={styles.amountCell}>AMOUNT</Text>
          </View>
          
          <View style={styles.tableRow}>
            <View style={styles.descriptionCell}>
              <Text>{planName}</Text>
              
            </View>
            <Text style={styles.unitPriceCell}>{'\u20B9'} {total/quantity}</Text>
            <Text style={styles.qtyCell}>{quantity}</Text>
            <Text style={styles.amountCell}>{'\u20B9'} {total}</Text>
          </View>
        </View>
        
        <View style={styles.totalSection}>
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Sub Total</Text>
            <Text style={styles.totalValue}>{total}</Text>
          </View>
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Total</Text>
            <Text style={styles.totalValue}>{'\u20B9'} {total}</Text>
          </View>
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Amount Paid</Text>
            <Text style={styles.totalValue}>{'\u20B9'} {total}</Text>
          </View>
          <Text style={styles.taxNote}>* 18% GST included in total payment</Text>
        </View>
        
        <View style={styles.amountPaidSection}>
          <Text style={styles.amountPaidTitle}>AMOUNT PAID</Text>
          <Text style={styles.amountPaidValue}>{'\u20B9'} {total}</Text>
          <Text style={styles.cancellationPolicy}>(Cancellation not available)</Text>
        </View>
        
        <View style={styles.footer}>
          <View>
            <Text style={styles.footerText}>ISSUED TO</Text>
            <Text style={styles.footerValue}>{customerName}</Text>
          </View>
          <View>
            <Text style={styles.footerText}>PAID ON</Text>
            <Text style={styles.footerValue}>{paidDate}</Text>
          </View>
        </View>
        
        {/* Thank You Card */}
        <View style={styles.thankYouCard}>
          <Text style={styles.thankYouText}>Thank you for your business!</Text>
          <Text style={styles.thankYouSubtext}>This is a computer generated invoice. No signature required.</Text>
        </View>
        
        <Text style={styles.pageNumber}>Page 1 of 1</Text>
      </Page>
    </Document>
  );
};

export default Invoice;